module.exports = __webpack_public_path__ + "img/bangmang.87cca6df.png";